import { render, staticRenderFns } from "./NewCommentModal.vue?vue&type=template&id=55dc8cac&"
import script from "./NewCommentModal.vue?vue&type=script&lang=ts&"
export * from "./NewCommentModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports